<template>
  <v-container
    class="main-form__container"
    :class="entity.collection"
    fluid
    grid-list-md
  >
    <v-card>
      <v-card-title class="main-form__container__title">
        <h2
          class="headline"
          primary-title
          v-text="formTitle"
        />

        <v-btn
          color="primary"
          @click="submit"
          v-text="'Salvar'"
          :disabled="isLoading"
        />
      </v-card-title>

      <vue-form-generator
        tag="div"
        style="entity.styles"
        :model="editingItem"
        :schema="entity.schema"
        :options="entity.formOptions"
      />

      <v-card-actions class="main-form__container__actions">
        <v-btn
          color="primary"
          @click="submit"
          v-text="'Salvar'"
          :disabled="isLoading"
        />
      </v-card-actions>
    </v-card>

  </v-container>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'

import VueFormGenerator from 'vue-form-generator'
import 'vue-form-generator/dist/vfg.css'

import fieldEditor from './customFields/fieldEditor'
import fieldGalleryCards from './customFields/fieldGalleryCards'
import fieldArray from './customFields/fieldArray'

Vue.use(VueFormGenerator)

Vue.component('fieldEditor', fieldEditor)
Vue.component('fieldGalleryCards', fieldGalleryCards)
Vue.component('fieldArray', fieldArray)

export default {
  name: 'CrudForm',
  data () {
    return {
      editingItem: null,
      formMode: 'create',
      dialog: false,
      errorMessages: '',
      snackbarMessage: '',
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({
      selectedItem: 'crud/selectedItem',
      listItems: 'crud/listItems',
      currentUser: 'authentication/currentUser'
    }),
    isDisabled: function () {
      return false
    },
    formTitle: function () {
      return (this.formMode === 'create' ? 'Incluir' : 'Editar') + ' ' + this.entity.name.singular
    },
    entity: function () {
      return this.$route.meta.entity
    }
  },
  methods: {
    ...mapActions({
      create: 'crud/createItem',
      edit: 'crud/updateItem',
      getItemById: 'crud/getItemById',
      clearSelected: 'crud/clearSelected'
    }),
    setBaseState: async function () {
      if (this.$route.params.id) {
        this.formMode = 'edit'

        this.editingItem = await this.getItemById({
          currentUserId: this.currentUser.uid,
          collection: this.entity.collection,
          id: this.$route.params.id
        })

        this.editingItem.id = this.$route.params.id

        console.log(this.editingItem)

        return
      }

      this.editingItem = this.entity.model
    },
    submit: async function () {
      this.disabled = true
      const params = {
        createdBy: this.currentUser.id,
        collection: this.entity.collection,
        item: this.editingItem
      }

      await this[this.formMode](params)
      alert('WOW! Parabéns, sua tarefa foi salva!')

      this.clearSelected()
      this.editingItem = null
      this.disabled = false

      this.$router.push({ path: '/' + this.entity.collection })
    },
    closeModal: function () {
    },
    showSnackbar: function (message) {
      this.snackbarMessage = message
      this.snackbar = true
    },
    hideSnackbar: function () {
      this.snackbarMessage = null
      this.snackbar = false
    }
  },
  async mounted () {
    // Styles
    const containerElement = document.getElementsByClassName('vue-form-generator')[0]
    Object.assign(containerElement.style, this.entity.styles)

    await this.setBaseState()
  }
}
</script>
<style lang="stylus">
  .main-form__container
    &__title
      display flex
      justify-content space-between

    &__actions
      display flex
      flex-direction row-reverse

  .vue-form-generator
    display grid
    grid-gap 30px
    grid-template-columns calc(50% - 15px) 1fr
    grid-template-areas  'main secondary' 'main tertiary'

    & > div
      display block
      border-radius 2px
      position relative
      box-shadow 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12)
      background #fff
      padding 20px

      &:nth-child(1)
        grid-area main

      &:nth-child(2)
        grid-area secondary

      &:nth-child(3)
        grid-area tertiary

      &:nth-child(4)
        grid-area quaternary

      &:nth-child(5)
        grid-area quinary

      &:nth-child(6)
        grid-area senary

      &:nth-child(7)
        grid-area septenary

      &:nth-child(8)
        grid-area octonary

      &:nth-child(9)
        grid-area nonary

      &:nth-child(10)
        grid-area denary

    .form-group
      label
        font-size 16px

      .radio-list
        display flex

        label
          margin-top 5px
          margin-right 30px
</style>
